var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgG = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.414 1H5.828A4.828 4.828 0 0 0 1 5.828v30.344A4.828 4.828 0 0 0 5.828 41h27.586a4.828 4.828 0 0 0 4.827-4.828V5.828A4.828 4.828 0 0 0 33.414 1Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.04 3.838H6.199a2.414 2.414 0 0 0-2.414 2.414v27.374A2.414 2.414 0 0 0 6.2 36.039h26.84a2.414 2.414 0 0 0 2.414-2.413V6.252a2.414 2.414 0 0 0-2.413-2.414Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.233 27c-1.032 0-1.913-.066-2.642-.199-.716-.132-1.314-.351-1.796-.656a3.24 3.24 0 0 1-1.093-1.273c-.262-.53-.447-1.193-.557-1.988-.097-.81-.145-1.77-.145-2.884 0-1.114.048-2.068.145-2.864.11-.808.295-1.478.557-2.008.275-.53.646-.948 1.114-1.253.482-.318 1.08-.544 1.796-.676.715-.133 1.589-.199 2.62-.199.455 0 .957.02 1.507.06.564.04 1.121.092 1.672.159.55.053 1.06.126 1.527.219v2.167a28.63 28.63 0 0 0-1.403-.159c-.454-.04-.867-.073-1.239-.1-.371-.026-.68-.04-.928-.04-.784 0-1.438.02-1.96.06-.524.027-.95.113-1.28.259-.33.146-.585.384-.764.716-.165.331-.282.795-.35 1.392-.07.583-.104 1.339-.104 2.267 0 .822.02 1.511.062 2.068.055.557.144 1.014.268 1.372.138.358.33.637.578.836.261.185.592.311.99.377.413.067.922.1 1.528.1h.68l.682-.04c.22-.013.399-.026.537-.04v-3.38H18.86v-2.228H24v7.497c-.468.093-.99.173-1.569.24-.577.052-1.141.099-1.692.138-.55.04-1.052.06-1.506.06Z",
    fill: "#fff"
  })));
};
export { SvgG as ReactComponent };